module.exports = __webpack_public_path__ + "static/img/articles-the-formation-opportunity.c9b5916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/articles-the-formation-opportunity.png
// module id = A3hG
// module chunks = 0